import React from "react";
import "../../Styles/certified/basilic.css";

export default function Finzly() {
  return (
    <>
      <div className="basilic-certified-details-section">
        <div className="basilic-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="basilic-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="basilic-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="basilic-certified-badge"
            />
            <div className="basilic-certified-company-names">
              <a href="https://basilicflystudio.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/basilic/basilic.png"
                alt="Walkzero Logo"
                className="basilic-certified-company-logo"
              />
            </a>
              <h1 className="basilic-certified-full-name">
              Basilic Fly Studio Ltd
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="basilic-certified-details-right">
            <img
              src="/assets/basilic/basilic_6.jpg"
              alt="Finzly Office"
              className="basilic-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="basilic-certified-description">
          <h2>
            Why  Basilic Fly Studio Ltd is an Outstanding Workplaces
          </h2>
          <p>
           Founded in 2013, Basilic Fly Studio has evolved from a small team of four professionals into a globally recognized visual effects company with over 900 artists and specialists across Chennai, Pune, London, Paris, and Vancouver. Renowned for delivering high-quality VFX solutions, the studio offers end-to-end services spanning pre-production, on-set supervision, creature creation, environmental development, roto, paint, tracking, FX, CG, compositing, and final delivery.


          </p>
          <p>
            Over the years, Basilic Fly has partnered with some of the world's leading studios, including Weta Digital, Framestore, Digital Domain, Scanline VFX, Pixomondo, and One of Us, contributing to acclaimed international film and television projects. Driven by a strong commitment to innovation, technical excellence, and creative storytelling, the company has established a robust India–Europe production pipeline that enables seamless collaboration and round-the-clock delivery.
          </p>
          <p>
           A significant milestone in the company's journey was its successful public listing, reflecting industry confidence in its vision and growth. Further strengthening its global presence, Basilic Fly Studio acquired the renowned London-based VFX studio One of Us, expanding its creative capabilities and international footprint. Today, the company continues to push the boundaries of visual storytelling, combining artistic talent, advanced technology, and global expertise to create compelling visual experiences for audiences worldwide.

          </p>
          
        </div>
        
        <div className="basilic-certified-info-cards">
          <div className="basilic-certified-info-card">
            <div className="basilic-certified-info-title">COMPANY SIZE</div>
            <div className="icom-certified-info-value">900 Employees</div>
          </div>
          <div className="basilic-certified-info-card">
            <div className="basilic-certified-info-title">INDUSTRY</div>
            <div className="basilic-certified-info-value">Media / VFX

</div>
          </div>
          <div className="basilic-certified-info-card">
            <div className="basilic-certified-info-title">CONNECT</div>
            <div className="basilic-certified-info-icons">
              <span className="basilic-certified-icon-round">
                <a href="https://basilicflystudio.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="basilic-certified-icon-round">
                <a href="https://www.linkedin.com/company/basilic-fly-studio/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="basilic-certified-icon-round">
                <a href="https://www.facebook.com/basilicflystudio" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="basilic-certified-info-card">
            <div className="basilic-certified-info-title">LOCATION (HQ)</div>
            <div className="basilic-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="basilic-certified-recognition-section">
          <h2 className="basilic-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="basilic-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="basilic-certified-recognition-image"
            />
          </div>
          <div className="basilic-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="basilic-certified-life-section">
          <h2 className="basilic-certified-life-title">
            Life at  Basilic Fly Studio Ltd
          </h2>
          <div className="basilic-certified-life-gallery">
            <div className="basilic-certified-life-col">
              <img src="/assets/basilic/basilic_1.JPG" alt="Office 1" className="basilic-certified-life-img" />
              <img src="/assets/basilic/basilic_2.jpg" alt="Team 1" className="basilic-certified-life-img" />
            </div>
            <div className="basilic-certified-life-col basilic-certified-life-center">
              <img src="/assets/basilic/basilic_5.jpg" alt="Main Office" className="basilic-certified-life-img basilic-certified-life-img-large" />
            </div>
            <div className="basilic-certified-life-col">
              <img src="/assets/basilic/basilic_3.png" alt="Office 2" className="basilic-certified-life-img" />
              <img src="/assets/basilic/basilic_4.jpg" alt="Team 2" className="basilic-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
